import axios from './axios';

export default {
    getAccess() {
        const options = {
            method: 'GET',
            url: 'external-product-images/access',
            headers: { 'content-type': 'application/json' },
        };

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => resolve(response.data))
                .catch(error => reject(error.message));
        });
    },
    getConfiguration() {
        return axios({
            method: 'GET',
            url: 'external-product-images/configuration',
            headers: { 'content-type': 'application/json' },
        }).then(response => response.data);
    },
    createConfiguration(data) {
        return axios({
            method: 'POST',
            url: 'external-product-images/configuration',
            headers: { 'content-type': 'application/json' },
            data
        }).then(response => response.data);
    },
    updateConfiguration(data) {
        return axios({
            method: 'PUT',
            url: 'external-product-images/configuration',
            headers: { 'content-type': 'application/json' },
            data
        }).then(response => response.data);
    },
    deleteConfiguration() {
        return axios({
            method: 'DELETE',
            url: 'external-product-images/configuration',
            headers: { 'content-type': 'application/json' },
        }).then(response => response.data);
    },
    pingConfiguration() {
        return axios({
            method: 'POST',
            url: 'external-product-images/configuration/ping',
            headers: { 'content-type': 'application/json' },
        }).then(response => response.data);
    },
    analyzeFiles(data) {
        return axios({
            method: 'POST',
            url: 'external-product-images/analyze',
            headers: { 'content-type': 'application/json' },
            data
        }).then(response => response.data);
    },
    prepareBatch(data) {
        return axios({
            method: 'POST',
            url: 'external-product-images/batches/prepare',
            headers: { 'content-type': 'application/json' },
            data
        }).then(response => response.data);
    },
    uploadBatchFile(batchId, data, onUploadProgress) {
        return axios({
            method: 'POST',
            url: `external-product-images/batches/${batchId}/upload`,
            data,
            noAutomaticRetry: true,
            onUploadProgress
        }).then(response => response.data);
    },
    associateBatch(batchId) {
        return axios({
            method: 'POST',
            url: `external-product-images/batches/${batchId}/associate`,
            noAutomaticRetry: true
        }).then(response => response.data);
    },
    getHistory(params) {
        return axios({
            method: 'GET',
            url: 'external-product-images/history',
            headers: { 'content-type': 'application/json' },
            params
        }).then(response => response.data);
    },
    getProductsWithoutImages(params) {
        return axios({
            method: 'GET',
            url: 'external-product-images/history/products-without-images',
            headers: { 'content-type': 'application/json' },
            params
        }).then(response => response.data);
    },
    updateHistoryRecord(imageId, data) {
        return axios({
            method: 'PATCH',
            url: `external-product-images/history/${imageId}`,
            headers: { 'content-type': 'application/json' },
            data
        }).then(response => response.data);
    },
    deleteHistoryRecord(imageId) {
        return axios({
            method: 'DELETE',
            url: `external-product-images/history/${imageId}`,
            headers: { 'content-type': 'application/json' }
        }).then(response => response.data);
    }
};
